import React from 'react';
import styled from 'styled-components';
import { FaClipboardList, FaShareAlt, FaUser } from 'react-icons/fa';
import { designTokens } from '../foundation/DesignTokens';
import { Drawer, DrawerList, DrawerItem } from './Drawer';

// Styled sidebar title
const SidebarTitle = styled.div`
  font-family: ${designTokens.fonts.heading};
  font-weight: 800;
  font-size: 1.25rem;
  color: ${designTokens.colors.gray[900]};
  margin-bottom: ${designTokens.spacing.xl};
  padding-left: 12px;
  display: flex;
  align-items: center;
  gap: ${designTokens.spacing.sm};

  @media (max-width: 900px) {
    font-size: 1.1rem;
    margin-bottom: ${designTokens.spacing.lg};
  }
`;

// Enhanced drawer item with better styling
const NavItem = styled(DrawerItem)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: ${designTokens.radius.md};
  color: ${designTokens.colors.gray[700]};
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95rem;
  margin-bottom: 4px;
  transition: all 0.2s ease;
  cursor: pointer;
  border: 1px solid transparent;
  background: transparent;
  width: 100%;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background-color: ${designTokens.colors.gray[50]};
    color: ${designTokens.colors.gray[900]};
  }

  ${(props) =>
    props.active &&
    `
    background-color: ${designTokens.colors.primary[50]};
    color: ${designTokens.colors.primary[600]};
    font-weight: 600;
    border-color: ${designTokens.colors.primary[100]};
  `}

  ${(props) =>
    props.disabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
  `}

  @media (max-width: 900px) {
    font-size: 0.87rem;
    padding: 10px 14px;
    gap: 10px;
  }
`;

// Icon wrapper
const NavIcon = styled.span`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.active ? 1 : 0.7)};
  transition: opacity 0.2s ease;

  svg {
    width: 16px;
    height: 16px;
  }

  @media (max-width: 900px) {
    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

// Navigation items configuration for Boards
const navigationItems = [
  {
    id: 'all',
    label: 'Todos los tableros',
    Icon: FaClipboardList,
  },
  {
    id: 'shared',
    label: 'Compartidos conmigo',
    Icon: FaShareAlt,
  },
  {
    id: 'mine',
    label: 'Mis tableros',
    Icon: FaUser,
  },
];

const BoardsNavigation = ({ activeView = 'all', onViewChange }) => {
  const handleNavClick = (item) => {
    if (item.disabled) return;

    if (onViewChange) {
      onViewChange(item.id);
    }
  };

  return (
    <Drawer>
      <SidebarTitle>Gestión de Tableros</SidebarTitle>

      <DrawerList>
        {navigationItems.map((item) => (
          <NavItem
            key={item.id}
            active={activeView === item.id}
            disabled={item.disabled}
            onClick={() => handleNavClick(item)}>
            <NavIcon active={activeView === item.id}><item.Icon /></NavIcon>
            {item.label}
          </NavItem>
        ))}
      </DrawerList>
    </Drawer>
  );
};

export default BoardsNavigation;
